import { render, staticRenderFns } from "./PromocionesFirma.vue?vue&type=template&id=7366f60e&"
import script from "./PromocionesFirma.vue?vue&type=script&lang=js&"
export * from "./PromocionesFirma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports